module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_6-179c68b6d89e7ef9308bc21166b384a7.png";